export default {
	SupOnlyDowns(state) {
		return state.SupOnlyDownList;
	},
	Total(state) {
		return state.Total;
	},
	IsLoading(state) {
		return state.IsLoading;
	}
};
